
import { CMSEnum } from './../../../models/enums/CMS/CMSEnum';
import { CmsService } from './../../../services/cms.service';
import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'home-middle-content',
  templateUrl: './home-middle-content.component.html',
  styleUrls: ['./home-middle-content.component.scss']
})
export class HomeMiddleContentComponent implements OnInit {

  HomeMiddleContent;

  constructor(
    private cmsService: CmsService,
    private sanitizer: DomSanitizer) { }


  ngOnInit(): void {
    this.cmsService.contentModel.subscribe(res => {
      if (res != null) {
        this.HomeMiddleContent = res.contents.filter(a => a.sectionID == CMSEnum.HomeMiddleContent);
        
      this.HomeMiddleContent.forEach(element => {
        element.contentText = this.getSafeHtml(element.contentText)
      });
      
      }
    })
  }

  getSafeHtml(value){
    return this.sanitizer.bypassSecurityTrustHtml(value)
  }

}



